import React, { useEffect, useRef, useState } from "react";
import UserAvatar from "../../pages/all-requests/components/UserAvatar";
import { CLOUDINARY_COMPLIANCE_BASE_URL } from "../../utils/enum";
import { umsRedirection } from "../../core/layouts/tc-layout/header-product-linking-dropdown-list";

function ProfileMenu({ userData, navigate, logout }) {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const profileMenuRef = useRef(null);

  const handleUmsRedirection = () => {
    const { redirectionKey, redirectionUrl } = umsRedirection();
    navigate(redirectionKey, redirectionUrl);
  };

  const { isInternalAdmin, isInternalUser, isAdmin, leadCameFrom = "" } = userData;
  const isAdminUser = isInternalAdmin || isInternalUser || isAdmin;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current?.contains(event.target)) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="tw-relative" ref={profileMenuRef}>
      <div onClick={() => setIsProfileMenuOpen(true)} className="tw-cursor-pointer">
        <UserAvatar name={userData?.fullName || "User"} showName={false} />
      </div>
      {isProfileMenuOpen && (
        <div className="tw-absolute tw-bg-white tw-rounded-lg tw-top-11 tw-right-0 tw-border tw-shadow-lg tw-border-gray-200 tw-min-w-56 tw-overflow-hidden">
          <div className="tw-flex tw-gap-2 tw-px-3 tw-py-2 tw-border-b">
            <UserAvatar name={userData?.fullName || "User"} showName={false} />
            <div>
              <div className="tw-text-label-md">{userData?.fullName}</div>
              <div className="tw-text-label-sm">{userData?.email}</div>
            </div>
          </div>

          <div className="tw-text-label-md hover:tw-bg-primary-purple-25 tw-px-3 tw-py-2 tw-cursor-pointer" onClick={() => navigate("profile")}>
            Profile Details
          </div>
          {leadCameFrom?.toLowerCase() !== "website" && (
            <div className="tw-text-label-md hover:tw-bg-primary-purple-25 tw-px-3 tw-py-2 tw-cursor-pointer" onClick={() => navigate("plans")}>
              Plan Details
            </div>
          )}

          {isAdminUser && (
            <div className="tw-text-label-md hover:tw-bg-primary-purple-25 tw-px-3 tw-py-2 tw-cursor-pointer tw-border-t" onClick={handleUmsRedirection}>
              User Management System
            </div>
          )}

          <div className="tw-text-label-md hover:tw-bg-primary-purple-25 tw-px-3 tw-py-2 tw-cursor-pointer tw-flex tw-items-center tw-border-t" onClick={logout}>
            <img src={`${CLOUDINARY_COMPLIANCE_BASE_URL}/v1707728252/intel/icons/xkb7yvj12tnggbc5ptve.svg`} alt="sign-out-icon" />
            Sign Out
          </div>
        </div>
      )}
    </div>
  );
}

export default ProfileMenu;
